import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../UIElements/Button";
import { Icon } from "../UIElements/Icon";
import { Skeleton } from "../Skeletons";

const CardBrandIcon = ({ brand }) => {
  const brandLower = (brand || "").toLowerCase();
  const label =
    brandLower === "visa"
      ? "Visa"
      : brandLower === "mastercard"
        ? "Mastercard"
        : brandLower === "amex"
          ? "Amex"
          : brand || "Card";

  return (
    <span className="bg-background border-border inline-flex items-center gap-1.5 rounded border px-2 py-1 text-xs font-medium">
      <Icon name="CreditCard" className="h-3.5 w-3.5" />
      {label}
    </span>
  );
};

const SavedCardsList = ({
  cards,
  selectedCardId,
  onSelectCard,
  isLoading,
  onAddCard,
}) => {
  const { t } = useTranslation(["billing"]);

  if (isLoading) {
    return (
      <div className="space-y-2">
        <Skeleton className="h-14 w-full rounded-lg" />
        <Skeleton className="h-14 w-full rounded-lg" />
      </div>
    );
  }

  if (!cards || cards.length === 0) {
    return (
      <div className="space-y-3">
        <p className="text-muted-foreground text-sm">{t("noCardsFound")}</p>
        <Button
          type="button"
          onClick={onAddCard}
          emphasis="link"
          intent="brand"
          size="touch"
          className="min-w-0 whitespace-normal"
        >
          {t("addAnotherCard")}
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {cards.map((card) => (
        <Button
          key={card.id}
          variant="ghost"
          size="touch"
          type="button"
          onClick={() => onSelectCard(card)}
          className={`border-border bg-muted flex w-full items-center justify-between rounded-lg border p-3 transition-colors ${
            selectedCardId === card.id
              ? "border-primary ring-primary/20 ring-1"
              : "hover:bg-accent"
          }`}
        >
          <div className="flex items-center gap-3">
            <CardBrandIcon brand={card?.data?.brand} />
            <span className="text-foreground text-sm">{card?.data?.last4}</span>
          </div>
          {selectedCardId === card.id && (
            <Icon name="Check" className="text-primary h-5 w-5" />
          )}
        </Button>
      ))}
      <Button
        type="button"
        onClick={onAddCard}
        emphasis="link"
        intent="brand"
        size="touch"
        className="mt-1 min-w-0 whitespace-normal"
      >
        {t("addAnotherCard")}
      </Button>
    </div>
  );
};

export default SavedCardsList;
